module.exports = __webpack_public_path__ + "img/Return.9a0ed6f1.png";